export default __webpack_public_path__ + "static/media/Mr. Ajaya Kumar Samal.39cf5297.png";